import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import GMATSubscriptionCheck from '../../RestAPI/GMATSubscription';
import PartnerGMATSubscriptionCheck from '../../RestAPI/PartnerSubscription/GMATSubscription';
import language from '../../../assets/languages/language';
import AlertMessage from '../../config/alertMessage';
import AppRoutes from '../../config/AppRoutes';
import Loader from '../../../common/loader';
import { showFailure } from '../../../common/toast';
import { renderHTMLContent } from '../../../common/function';
/* eslint-disable*/
class ViewGMATques extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      questions: [],
      SubsciptionMessage: AlertMessage.messageContent_gmat,
      token: '',
      idname: '',
      readingName: this.props.params.reading,
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 1000,
      answered: [],
      answered_state: [],
      subscriptionstatus: this.props.params.subscriptionstatus,
      chapters: [],
      subscription_details: '',
      showFreePremium: true,
      subscription_details_for_isActive: '',
      chapter_video_redirect: '',
      selectedmenu: 'gmat',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      isVideo: true,
      display_loader: 'show',
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  _goToVideo = () => {
    this.setState(
      {
        chapter_video_redirect: this.state.chapters[parseInt(this.props.params.chapter_no) - 1],
      },
      () => {
        this.context.router.push({
          pathname: AppRoutes.GMAT_VIDEO_DISPLAY.replace(
            ':id',
            this.state.chapter_video_redirect.chapter_no,
          ).replace(':showFreePremium', this.state.showFreePremium ? 0 : 1),
          // .replace(':type', '')
          // .replace(':chapter_id', '')
          // .replace(':index', '')
          search: `?chapter_name=${this.state.chapter_video_redirect.chapter_name}`,
        });
      },
    );
  };

  _getReadings = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_READING.replace(':id', this.props.params.chapter_no),

      // `/readings/${this.props.params.chapter_no}`,
      // state: {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   chapter: this.props.location.state.reading.chapter_no,
      // },
    });
  };

  _beginChapter = (item, index, caseOffset, questionOffset, e) => {
    const { readingDetails: reading } = this.state;
    if (reading.type === 'case_question') {
      this.context.router.push({
        pathname: AppRoutes.GMAT_BEGINCASE.replace(':chapterid', item.chapter_id)
          .replace(':readingid', reading.id)
          .replace(':caseid', item.case_id)
          .replace(':case_offset', caseOffset)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_number', item.id)
          .replace(':offset', questionOffset),
      });
    } else if (
      reading.type === 'tab_question' ||
      reading.type === 'graph_question' ||
      reading.type === 'table_question' ||
      reading.type === 'two_part_question'
    ) {
      let routeName;
      switch (reading.type) {
        case 'tab_question':
          routeName = 'GMAT_TAB';
          break;
        case 'graph_question':
          routeName = 'GMAT_GRAPH_MULTI_STATEMENT';
          break;
        case 'table_question':
          routeName = 'GMAT_TABLE';
          break;
        case 'two_part_question':
          routeName = 'GMAT_TWO_PART_STATEMENT';
          break;
        default:
          console.log('Route Name issue');
          break;
      }
      this.context.router.push({
        pathname: AppRoutes[routeName]
          .replace(':chapterid', item.chapter_id)
          .replace(':readingid', reading.id)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_id', item.id)
          .replace(':offset', index)
          .replace(':reading', reading.reading),
      });
    } else {
      this.context.router.push({
        pathname: AppRoutes.GMAT_QUESTION_BANK_VIEW_QUE.replace(':notesid', item.chapter_id)
          .replace(':readingid', item.reading_id)
          .replace(':id', item.id),
      });
    }
  };

  _getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  async componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    const getProfileInfo = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfo).then(
      async resp => {
        if (resp.profileInfo) {
          this.setState({
            isVideo: resp.profileInfo.isVideo,
          });
        }
      },
    );
    var data_data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    await FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATVideos', data_data).then(
      resp => {
        if (resp.success) {
          this.setState({ ValidToken: true, chapters: resp.cfavideo });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );

    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_selected === '') {
          this.setState({
            showFreePremium: true,
          });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            idname: storage_session['idname'],
            token: storage_session['token'],
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage == '' &&
          resp.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          // console.log('if working')
          showFailure('Please upgrade your package to access all questions');

          this.setState({
            showFreePremium: true,
          });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            idname: storage_session['idname'],
            token: storage_session['token'],
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = GMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                // console.log(isInArray_var);
                if (isInArray_var) {
                  // console.log('IF WORKING')
                  this.setState({ showFreePremium: false });
                } else {
                  showFailure('Please upgrade your package to access all questions');
                  //   console.log('ELSE WORKING')
                  this.setState({ showFreePremium: true });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });

    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      reading_id: this.props.params.id,
      chapter_id: this.props.params.chapter_no,
      offset: this.state.offset,
      limit: this.state.limit,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    await FD.callAPI(App_data.backend_api + '/gmat_question_bank/getQuestions', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          questions: resp.questions,
          readingDetails: resp.readingDetails,
        });
      } else {
        this.setState({ ValidToken: false });
      }
      this.setState({ display_loader: 'hide' });
      return resp;
    });
  }

  render() {
    let questions = this.state.questions;
    let data = '';
    let caseOffset = -1;
    let questionOffset = 0;
    let previousCaseId = undefined;
    if (this.state.questions.length) {
      data = questions.map((item, index) => (
        <div key={index} className='col-md-6 col-lg-4'>
          <div className='d-none'>
            {previousCaseId === item.case_id ? questionOffset++ : (questionOffset = 0)}
          </div>
          <div className='d-none'>
            {previousCaseId === item.case_id ? (caseOffset = caseOffset) : caseOffset++}
          </div>
          <div className='d-none'>{(previousCaseId = item.case_id)}</div>
          <div
            onClick={this._beginChapter.bind(this, item, index, caseOffset, questionOffset)}
            className='border_box'
          >
            <div className='border_box_title d-flex'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon-blu.svg'}
                className='margin_bottom_20'
                width='30'
                alt=''
              />
              <p className='ml-1'>
                {item.name ? item.name : this.state.readingName} ({language.LC().Q} {item.id})
              </p>
            </div>
            <div className='padding_box'>
              <div contentEditable='false' className='view_question_height view_questionhtml'>
                {renderHTMLContent(
                  item.question.substring(
                    0,
                    item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 500,
                  ) + '...'
                )}
              </div>
              <p>{this.state.answered_state[index]}</p>
              <UserInfo
                itemid={item.id}
                chapter_id={this.props.params.chapter_no}
                reading_id={this.props.params.id}
                idname={this.state.idname}
                token={this.state.token}
                answered_state={index}
                readingDetails={this.state.readingDetails}
              />
            </div>
          </div>
        </div>
      ));
    } else {
      data = this.state.display_loader === 'show' ? <Loader /> : null;
    }

    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>{this.state.readingName}</h1>
          </div>

          <div
            className={
              // this.state.isVideo === true
              //   ? `col-md-2 text-md-right margin_bottom_20`
              // :
              `col-md-4 text-md-right margin_bottom_20`
            }
          >
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {' '}
              {language.LC().CHANGE_READING}{' '}
            </button>
          </div>
          {/* {this.state.isVideo === true ? (
            <div className='col-md-2 text-md-right margin_bottom_20'>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._goToVideo}
              >
                {' '}
                {language.LC().GO_TO_VIDEOS}
              </button>
            </div>
          ) : null} */}
        </div>
        <div className='row'>
          {data}
          {this.state.subscriptionstatus == 'free' ? (
            <div className='col-md-6 col-lg-4'>
              <div className='border_box' onClick={this._getSubscribe}>
                <div className='border_box_title'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/question_icon-blu.svg'}
                    className='margin_bottom_20'
                    width='30'
                    alt=''
                  />
                  <p> {language.LC().SUBSCRIBE_FOR_1000_PRACTICE_QUESTIONS} </p>
                </div>
                <div className='padding_box_free'>
                  {renderHTMLContent(
                    this.state.SubsciptionMessage,
                    "div",
                    "view_question_height view_questionhtml modal-info-view-for-plan",
                    { contentEditable: 'false' }
                  )}
                </div>
                <div className='subscibe__btn text-center'>
                  <button
                    type='button'
                    className='btn btn-primary pointer_class'
                    onClick={this._getSubscribe}
                  >
                    {language.LC().SUBSCRIBE}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

function UserInfo(props) {
  var data = {
    itemid: props.itemid,
    chapter_id: props.chapter_id,
    reading_id: props.reading_id,
    idname: props.idname,
    token: props.token,
    type: props.readingDetails.type,
  };

  FD.callAPI(App_data.backend_api + '/gmat_question_bank/getQuestionsByuser', data).then(resp => {
    // console.log('abc'+props.answered_state+'------'+resp.success);
    if (resp.success) {
      if (resp.success == 'success') {
        document.getElementById('user_question_status' + props.answered_state).innerHTML =
          'Answered';
        document.getElementById('user_question_status' + props.answered_state).id =
          'answered_status';
      } else {
        document.getElementById('user_question_status' + props.answered_state).innerHTML =
          'Not Answered';
        document.getElementById('user_question_status' + props.answered_state).id =
          'notanswered_status';
      }
    } else {
      document.getElementById('user_question_status' + props.answered_state).innerHTML =
        resp.success;
    }
  });

  return (
    <div>
      <div id={'user_question_status' + props.answered_state} />
    </div>
  );
}
export default ViewGMATques;



// WEBPACK FOOTER //
// ./src/views/GMAT/QuestionBank/Viewques.js